import type { Translations } from './keys'

export const en: Translations = {
  loading: "Loading...",
  error: "Error",
  success: "Success",
  cancel: "Cancel",
  delete: "Delete",
  save: "Save",
  my_products: "My Products",
  sign_out: "Sign Out",
  skip: "Skip",
  no_products: "No products yet",
  tap_camera: "Tap the camera button to add your first product",
  delete_confirm: "Are you sure you want to delete this product?",
  selling: "Selling",
  my_lists: "My Lists",
  account: "Account",
  drafts: "Drafts",
  items_to_link: "items ready to link",
  no_drafts: "No draft items",
  my_reservations: "My Reservations",
  active_booths: "View your active booths",
  manage_stores: "Manage your stores",
  favorites: "Favorites",
  saved_items: "saved items",
  no_favorites: "No favorites yet",
  favorites_hint: "Browse products and tap the heart to save them here",
  profile: "Profile",
  profile_settings: "Profile Settings",
  edit_profile: "Edit your profile and preferences",
  user: "User",
  public_profile: "Public Profile",
  display_name: "Display Name",
  display_name_placeholder: "Your seller name",
  display_name_hint: "This is shown publicly on your products",
  personal_info: "Personal Info",
  first_name: "First Name",
  last_name: "Last Name",
  phone_placeholder: "+358 40 123 4567",
  preferences: "Preferences",
  profile_updated: "Your profile has been updated",
  profile_update_failed: "Failed to update profile",
  draft_products_info: "These products are not yet linked to any booth. Long press to select multiple.",
  create_products_hint: "Take photos of items you want to sell",
  delete_products: "Delete Products",
  delete_products_confirm: "Are you sure you want to delete the selected products?",
  link_to_booth: "Link to Booth",
  select_all_items: "Select All",
  deselect_all_items: "Deselect All",
  single_item: "item",
  browse_products: "Browse Products",
  ai_label: "AI Label",
  captured: "Captured",
  uploading: "uploading",
  camera_permission: "Camera permission is required to add products",
  grant_permission: "Grant Permission",
  camera: "Camera",
  gallery: "Gallery",
  barcode: "Barcode",
  status: "Status",
  title_optional: "Title (optional)",
  enter_title: "Enter product title",
  description_optional: "Description (optional)",
  enter_description: "Enter product description",
  price_required: "Price (€) *",
  approve_publish: "Approve & Publish",
  save_draft: "Save as Draft",
  delete_product: "Delete Product",
  ai_suggest: "AI Suggest",
  product_published: "Product published!",
  draft_saved: "Draft saved!",
  valid_price_required: "Please enter a valid price",
  no_image_for_ai: "No image available for AI analysis",
  ai_failed: "Failed to get AI suggestions. Please try again.",
  draft: "draft",
  for_sale: "for sale",
  sold: "sold",
  reserved: "reserved",
  returned: "returned",
  sign_in_email: "Sign in with Email",
  sign_in_google: "Sign in with Google",
  email: "Email",
  password: "Password",
  language: "Language",
  english: "English",
  finnish: "Finnish",
  markets: "Markets",
  flea_markets: "Flea Markets",
  my_markets: "My Markets",
  join_market: "Join Market",
  create_market: "Create Market",
  enter_invite_code: "Enter invite code",
  join: "Join",
  joining: "Joining...",
  invalid_code: "Invalid invite code",
  already_member: "Already a member of this market",
  joined_market: "Successfully joined market!",
  market_name: "Market Name",
  market_description: "Description (optional)",
  market_address: "Address (optional)",
  commission_rate: "Commission Rate (%)",
  creating: "Creating...",
  create: "Create",
  market_created: "Market created successfully!",
  back: "Back",
  sellers: "Sellers",
  active_sellers: "Active Sellers",
  pending_requests: "Pending Requests",
  products_for_sale: "Products For Sale",
  total_sales: "Total Sales",
  invite_code: "Invite Code",
  manage_sellers: "Manage Sellers",
  edit_settings: "Edit Settings",
  no_markets: "You are not a member of any markets yet",
  pending: "pending",
  approved: "approved",
  rejected: "rejected",
  suspended: "suspended",
  all: "All",
  confirm: "Confirm",
  confirm_approve: "Approve this seller?",
  confirm_reject: "Reject this seller?",
  approve: "Approve",
  reject: "Reject",
  seller_approved: "Seller approved!",
  seller_rejected: "Seller rejected",
  update_failed: "Failed to update",
  suspend: "Suspend",
  reactivate: "Reactivate",
  no_pending_sellers: "No pending requests",
  no_sellers: "No sellers with reservations yet",
  no_active_sellers: "No active sellers",
  joined: "Joined",
  reservations_count: "reservations",
  active: "Active",
  past: "Past",
  view_products: "View Products",
  confirm_cancel_reservation: "Cancel this reservation?",
  reservation_cancelled: "Reservation cancelled",
  cancel_failed: "Failed to cancel",
  yes: "Yes",
  no: "No",
  edit_commission: "Edit Commission",
  commission_percentage: "Commission %",
  commission_updated: "Commission rate updated!",
  commission_hint: "Percentage kept by the store on consignment sales",
  delete_store: "Delete Store",
  delete_store_confirm: "Are you sure you want to delete this store? All products will also be deleted.",
  store_updated: "Store updated successfully!",
  store_deleted: "Store deleted",
  spaces: "Spaces",
  manage_spaces: "Manage Spaces",
  add_space: "Add Space",
  edit_space: "Edit Space",
  no_spaces: "No spaces yet. Add your first booth or rack!",
  space_created: "Space created!",
  space_updated: "Space updated!",
  confirm_delete_space: "Delete this space?",
  available: "available",
  occupied: "occupied",
  maintenance: "maintenance",
  space_type_booth: "Booth",
  space_type_rack: "Rack",
  space_type_table: "Table",
  space_type_shelf: "Shelf",
  space_type_corner: "Corner",
  space_type_other: "Other",
  location: "Location",
  zone: "Zone",
  row: "Row",
  number: "Number",
  dimensions_cm: "Dimensions (cm)",
  width: "Width",
  depth: "Depth",
  height: "Height",
  pricing: "Pricing",
  per_day: "Per Day",
  per_week: "Per Week",
  per_month: "Per Month",
  features: "Features",
  electricity: "Electricity",
  lighting: "Lighting",
  accessible: "Accessible",
  name: "Name",
  type: "Type",
  description: "Description",
  optional: "Optional",
  add: "Add",
  duplicate: "Copy",
  space_duplicated: "Space duplicated!",
  my_managed_markets: "Markets I Manage",
  my_memberships: "My Memberships",
  available_markets: "Available Markets",
  no_markets_available: "No markets available in your area yet",
  spaces_available: "spaces available",
  apply: "Apply",
  application_sent: "Application sent! Waiting for approval.",
  apply_failed: "Failed to apply",
  floor_plan: "Floor Plan",
  floor_plan_editor: "Floor Plan Editor",
  add_floor: "Add Floor",
  floor_name: "Floor Name",
  floor_name_placeholder: "e.g. Main Hall, Floor 1",
  dimensions: "Dimensions",
  dimensions_hint: "1000cm = 10 meters. Default is 10m × 8m.",
  create_floor_hint: "Create a floor to start designing your layout",
  add_table_type: "Add Table Type",
  new_table: "New Table",
  presets: "Quick Presets",
  custom: "Custom",
  create_and_add: "Create & Add",
  copied: "Copied",
  click_to_paste: "Click on the floor to paste",
  pasting: "Pasting",
  prefix: "Prefix",
  start: "Start",
  next: "Next",
  copy: "Copy",
  floor_dimensions: "Floor Area Dimensions",
  width_m: "Width (m)",
  depth_m: "Depth (m)",
  floor_dimensions_hint_m: "Enter the actual floor area dimensions in meters.",
  confirm_delete_floor: "Are you sure you want to delete this floor? All spots on this floor will also be deleted.",
  save_changes: "Save Changes",
  overlap_error: "Cannot Place Here",
  overlap_message: "This position overlaps with another table. Please choose a different location.",
  fit: "Fit",
  create_floor: "Create Floor",
  no_floor_selected: "No floor selected",
  add_spot_type: "Add Spot Type",
  type_name: "Type Name",
  type_name_placeholder: "e.g. Small Table, Large Booth",
  color: "Color",
  create_type: "Create Type",
  new_type: "New Type",
  enter_floor_name: "Please enter a floor name",
  enter_spot_type_name: "Please enter a name",
  enter_at_least_one_price: "Please enter at least one price",
  select_floor_and_type: "Please select a floor and spot type first",
  spots: "Spots",
  types: "Types",
  delete_spot: "Delete Spot",
  confirm_delete_spot: "Are you sure you want to delete this spot?",
  position: "Position",
  rotation: "Rotation",
  rotate: "Rotate",
  select_space: "Select a Space",
  no_floor_plan: "No floor plan available for this market",
  no_spots_on_floor: "No spots on this floor",
  show_available_only: "Available only",
  tap_spot_to_reserve: "Tap an available spot to reserve it",
  loading_availability: "Loading availability...",
  your_selection: "Your selection",
  reservation_created: "Space reserved successfully!",
  login_to_reserve: "Please log in to make a reservation",
  spot_details: "Spot Details",
  map_view: "Map View",
  list_view: "List View",
  floor: "Floor",
  spot: "Spot",
  spot_number: "Spot Number",
  edit_floor: "Edit Floor",
  delete_floor: "Delete Floor",
  floor_deleted: "Floor deleted",
  spot_type: "Spot Type",
  edit_spot_type: "Edit Spot Type",
  delete_spot_type: "Delete Spot Type",
  spot_type_deleted: "Spot type deleted",
  spot_added: "Spot added",
  spot_updated: "Spot updated",
  spot_deleted: "Spot deleted",
  click_to_add_spot: "Click on the canvas to add a spot",
  drag_to_move: "Drag spots to reposition them",
  select_mode: "Select Mode",
  add_mode: "Add Mode",
  no_spots_created: "No spots have been created yet",
  create_spots_hint: "Use the Floor Plan Editor to add tables to your market",
  open_floor_plan: "Open Floor Plan Editor",
  edit_spot: "Edit Spot",
  is_active: "Active",
  is_available: "Available for Booking",
  notes: "Notes",
  notes_placeholder: "Add notes about this spot...",
  current_reservation: "Current Reservation",
  no_pricing: "No pricing set",
  price_per_day: "Price per Day",
  price_per_week: "Price per Week",
  price_per_month: "Price per Month",
  edit_dimensions_hint: "Dimensions can be changed in the Floor Plan Editor",
  unavailable: "Unavailable",
  reservations: "Reservations",
  view_reservations: "View Reservations",
  no_reservations: "No reservations yet",
  confirm_reservation: "Confirm Reservation",
  cancel_reservation: "Cancel this reservation?",
  cancel_action: "Cancel It",
  decline: "Decline",
  mark_completed: "Mark Completed",
  status_updated: "Status updated!",
  confirmed: "confirmed",
  cancelled: "cancelled",
  completed: "completed",
  unpaid: "unpaid",
  partial: "partial",
  paid: "paid",
  refunded: "refunded",
  browse: "Browse",
  sell: "Sell",
  find_market_book_table: "Find a flea market and book a table",
  search_products: "Search products...",
  all_markets: "All Markets",
  no_results: "No products found",
  no_products_available: "No products available yet",
  untitled: "Untitled",
  listed: "Listed",
  product_not_found: "Product not found",
  go_back: "Go Back",
  tap_for_directions: "Tap for directions",
  seller: "Seller",
  product_code: "Product Code",
  edit_product: "Edit Product",
  available_spaces: "Available Spaces",
  no_available_spaces: "No available spaces at the moment",
  tap_to_reserve: "Tap to reserve",
  reserve_space: "Reserve Space",
  start_date: "Start Date",
  end_date: "End Date",
  total_price: "Total Price",
  submit_reservation: "Submit Reservation Request",
  reservation_submitted: "Reservation Submitted",
  reservation_failed: "Failed to submit reservation",
  space_already_reserved: "This space is already reserved for those dates",
  invalid_dates: "Invalid dates selected",
  reservation_note: "Your reservation will be reviewed by the market admin.",
  browse_spaces: "Reserve a Space",
  reserve_spot: "Reserve Spot",
  spot_unavailable: "Spot Unavailable",
  spot_unavailable_message: "This spot is currently not available for reservation.",
  reservation_submitted_message: "Your reservation request has been submitted. The market admin will review and confirm it.",
  proceed_to_reserve: "Proceed to Reserve",
  contact_for_pricing: "Contact market for pricing",
  select_duration: "Select Duration",
  spot_rental: "Spot Rental",
  commission_on_sales: "Commission on sales",
  total_to_pay: "Total to pay",
  reservation_confirmed_message: "Your spot has been reserved. You can now add products to sell.",
  commission: "commission",
  select: "Select",
  duration: "Duration",
  day: "day",
  days: "days",
  week: "week",
  month: "month",
  later: "Later",
  add_products: "Add Products",
  no_reservations_home: "No reservations",
  reserve_space_first: "Reserve a space at a market to start selling",
  browse_markets: "Browse Markets",
  take_photos: "Take Photos",
  from_gallery: "From Gallery",
  link_products: "Link Products",
  manage: "Manage",
  linked_products: "Linked Products",
  no_products_yet: "No products yet",
  add_products_hint: "Use the buttons above to add products",
  select_products_to_link: "Select products to link to this reservation",
  no_products_to_link: "No products available to link",
  add_products_first: "Add products using the camera or gallery first",
  reservation_confirmed: "Space reserved! Would you like to add products now?",
  reservation_instant_note: "Your reservation is confirmed instantly. Payment can be made later.",
  reserve_now: "Reserve Now",
  coming_soon: "Coming soon",
  reservation_not_found: "Reservation not found. Refreshing data...",
  link_error: "Failed to link products. Please try again.",
  analyzing: "Analyzing",
  images_count: "images",
  upcoming_sales: "Upcoming Sales",
  upcoming: "Upcoming",
  now_on: "Now on!",
  no_upcoming_sales: "No upcoming sales at the moment",
  check_back_soon: "Check back soon for new items!",
  bulk_upload: "Bulk Upload",
  default_price: "Default price",
  apply_all: "Apply All",
  add_images: "Add Images",
  no_images_selected: "No images selected",
  tap_add_images: "Tap \"Add Images\" to select photos",
  upload_all: "Upload All",
  uploaded: "uploaded",
  uploaded_count: "Uploaded",
  title: "Title",
  selected: "selected",
  items_copied: "copied",
  click_to_paste_items: "click to paste",
  select_all: "All",
  link: "Link",
  products: "products",
  linked_count: "Linked",
  no_confirmed_reservations: "You need a confirmed reservation to link products.",
  bulk_link_prompt: "Link",
  to: "to",
  enter_number: "Enter number",
  stores: "Stores",
  my_stores: "My Stores",
  store: "Store",
  no_stores: "No stores yet",
  create_store: "Create Store",
  create_store_hint: "Create your own second-hand store to manage inventory directly",
  add_store: "Add Store",
  inventory: "Inventory",
  store_owned: "Store Owned",
  consignment: "Consignment",
  consign: "Consign",
  total: "Total",
  status_active: "Active",
  add_product_hint: "Tap the camera button to add products",
  store_name: "Store Name",
  store_name_placeholder: "e.g. Vintage Treasures Helsinki",
  store_type: "Store Type",
  city: "City",
  city_placeholder: "e.g. Helsinki",
  store_description_placeholder: "Describe your store...",
  enter_store_name: "Please enter a store name",
  login_required: "You must be logged in",
  store_created: "Store created successfully!",
  consignment_info: "Consignment Store",
  consignment_hint: "You can accept items from sellers and split the revenue. Default commission is 30%.",
  suppliers: "Suppliers",
  add_supplier: "Add Supplier",
  edit_supplier: "Edit Supplier",
  supplier_name: "Supplier Name",
  supplier_name_placeholder: "e.g. ABC Wholesale",
  contact_name: "Contact Name",
  contact_name_placeholder: "e.g. John Smith",
  no_suppliers: "No suppliers yet",
  add_supplier_hint: "Add suppliers to track where your products come from",
  supplier_created: "Supplier created!",
  supplier_updated: "Supplier updated!",
  delete_supplier: "Delete Supplier",
  confirm_delete_supplier: "Are you sure you want to delete this supplier?",
  supplier_has_products: "Cannot delete supplier with linked products",
  street_address: "Street address",
  business_info: "Business Info",
  business_id: "Business ID",
  payment_terms: "Payment Terms",
  inventory_reports: "Inventory Reports",
  overview: "Overview",
  low_stock: "Low Stock",
  movements: "Movements",
  total_units: "Total Units",
  units_for_sale: "Units For Sale",
  inventory_value: "Inventory Value",
  cost_value: "Cost Value",
  retail_value: "Retail Value",
  potential_profit: "Potential Profit",
  low_stock_alert: "Low Stock Alert",
  products_need_restocking: "products need restocking",
  top_selling: "Top Selling",
  no_low_stock: "No low stock items",
  all_items_stocked: "All items are well stocked",
  threshold: "Threshold",
  cost: "Cost",
  no_movements: "No stock movements",
  movements_will_appear: "Stock movements will appear here",
  stock_quantity: "Stock Quantity",
  sku: "SKU",
  supplier: "Supplier",
  reorder_quantity: "Reorder Quantity",
  low_stock_threshold: "Low Stock Alert",
  self_service_flea_market: "Self-Service Flea Market",
  self_service_flea_market_desc: "Sellers manage their own items and sales",
  full_service_flea_market: "Full-Service Flea Market",
  full_service_flea_market_desc: "Staff handles sales on behalf of sellers",
  consignment_store: "Consignment Store",
  consignment_store_desc: "Accept items from sellers and split revenue",
  retail_store: "Used Goods Retailer",
  retail_store_desc: "Store-owned inventory only",
  antique_shop: "Antique Shop",
  vintage_store: "Vintage Store",
  thrift_store: "Thrift Store",
  flea_market: "Flea Market",
  select_store_type: "What type of store are you creating?",
  flea_market_type: "Flea Market Type",
  select_flea_market_type: "What type of flea market are you creating?",
  commission_rate_label: "Commission Rate (%)",
  commission_rate_hint: "Your cut from each sale",
  space_rental: "Space Rental",
  space_rental_hint: "Sellers rent spaces and manage their own sales",
  accepts_consignment: "Accept Sales Offers",
  accepts_consignment_hint: "Allow sellers to offer items for sale through the platform",
  default_commission: "Default Commission",
  retail_store_hint: "All inventory is owned by the store. Perfect for buying and reselling items.",
  selling_model: "Selling Model",
  selling_model_hint: "How do sellers participate in your market?",
  booth_based: "Booth-Based",
  booth_based_desc: "Sellers get their own designated space to display items",
  inventory_based: "Shared Inventory",
  inventory_based_desc: "Items are mixed in a shared display area managed by you",
  consignment_period: "Consignment Period",
  consignment_period_hint: "How long items stay before being returned to seller",
  payout_schedule: "Payout Schedule",
  payout_schedule_hint: "How often sellers receive their earnings",
  per_sale: "Per Sale",
  weekly: "Weekly",
  monthly: "Monthly",
  commission_breakdown: "Commission Breakdown",
  platform_provision: "Platform Fee",
  platform_provision_hint: "Covers payment processing and platform costs",
  market_commission: "Your Commission",
  market_commission_hint: "Your share from each sale",
  total_provision: "Total",
  total_provision_hint: "Total deducted from seller earnings",
  basic_info_hint: "Tell us about your store",
  street_address_placeholder: "e.g. Mannerheimintie 1",
  business_settings: "Business Settings",
  business_settings_hint: "Configure your pricing and payments",
  payment_methods: "Payment Methods",
  payment_methods_hint: "Select accepted payment methods",
  cash: "Cash",
  card: "Card",
  bank_transfer: "Bank Transfer",
  operations: "Operations",
  operations_hint: "How does your store operate?",
  event_based: "Event-Based",
  event_based_hint: "This is a one-time or recurring event, not a permanent location",
  space_rental_setup_hint: "You can configure spaces and pricing after creating the market",
  accepted_categories: "Accepted Categories",
  accepted_categories_hint: "What types of items do you accept?",
  min_item_value: "Minimum Item Value",
  min_item_value_hint: "Minimum value for items you accept (0 for no minimum)",
  seller_terms: "Seller Terms",
  seller_terms_placeholder: "Enter any terms or conditions for sellers...",
  seller_terms_hint: "Rules and conditions sellers must agree to",
  review: "Review",
  review_hint: "Review your store details before creating",
  continue: "Continue",
  clothing: "Clothing",
  furniture: "Furniture",
  electronics: "Electronics",
  books: "Books",
  toys: "Toys",
  sports: "Sports",
  home_decor: "Home Decor",
  antiques: "Antiques",
  jewelry: "Jewelry",
  other: "Other",
  management: "Management",
  spaces_hint: "Tables, booths, and racks",
  sellers_hint: "Approve and manage sellers",
  pending_applications: "pending applications",
  reservations_hint: "Space bookings and schedules",
  settings: "Settings",
  market_info: "Market Info",
  edit: "Edit",
  market_not_found: "Market not found",
  code_copied: "Invite code copied!",
  invalid_commission: "Commission must be between 0 and 100",
  space_name: "Space Name",
  space_name_placeholder: "e.g. Table A1",
  add_new_space: "Add New Space",
  market_name_placeholder: "e.g. Sunday Flea Market",
  market_description_placeholder: "Describe your flea market...",
  delete_market: "Delete Market",
  delete_market_confirm: "Are you sure you want to delete this flea market? All spaces, reservations, and products will also be deleted.",
  market_deleted: "Market deleted",
  seller_app: "Seller App",
  sign_in: "Sign In",
  sign_up: "Sign Up",
  login_as_merchant: "Login as Merchant",
  continue_with_google: "Continue with Google",
  sign_in_with_email: "Sign in with Email",
  already_have_account: "Already have an account? Sign In",
  no_account: "Don't have an account? Sign Up",
  or: "or",
  merchant_login: "Merchant Login",
  for_store_owners: "For store owners",
  merchant: "Merchant",
  merchant_portal: "Merchant Portal",
  merchant_portal_desc: "Access your store dashboard and manage inventory",
  enter_email_password: "Please enter email and password",
  check_email: "Check your email for verification link",
  select_store: "Select Store",
  select_store_to_manage: "Select a store to manage",
  create_new_store: "Create New Store",
  create_first_store: "Create your first store to get started",
  dashboard: "Dashboard",
  total_products: "Total Products",
  active_products: "Active Products",
  sold_today: "Sold Today",
  revenue_today: "Revenue Today",
  quick_actions: "Quick Actions",
  view_inventory: "View Inventory",
  store_settings: "Store Settings",
  manage_staff: "Manage Staff",
  switch_store: "Switch Store",
  logout: "Logout",
  search: "Search",
  home: "Home",
  pos: "POS",
  activity: "Activity",
  more: "More",
  point_of_sale: "Point of Sale",
  scan_or_search: "Scan barcode or search products...",
  ready_to_scan: "Ready to scan",
  scan_barcode_hint: "Scan a barcode or type to search for products",
  cart: "Cart",
  cart_empty: "Cart is empty",
  cash_received: "Cash received",
  change: "Change",
  complete_sale: "Complete Sale",
  sale_completed: "Sale completed!",
  quick_sale: "Quick Sale",
  quick_sale_desc: "Start a new sale",
  add_product_desc: "Camera or gallery",
  kassa: "Kassa",
  take_photo_desc: "Take a photo",
  pick_from_gallery_desc: "Pick from gallery",
  reports_desc: "View analytics",
  recent_sales: "Recent Sales",
  view_all: "View all",
  low_in_stock: "running low",
  pending_offers: "Pending offers",
  offers_to_review: "offers to review",
  no_sales_yet: "No sales yet",
  sales_will_appear_here: "Sales will appear here",
  offers_will_appear_here: "Incoming offers will appear here",
  no_payouts_yet: "No payouts yet",
  payouts_will_appear_here: "Seller payouts will appear here",
  store_management: "Store Management",
  store_settings_desc: "Name, hours, contact info",
  staff_management: "Staff Management",
  staff_desc: "Manage team members and roles",
  categories_desc: "Organize your products",
  inventory_orders: "Inventory & Orders",
  suppliers_desc: "Manage your suppliers",
  purchase_orders_desc: "Track incoming stock",
  stock_adjustment_desc: "Counts, damages, returns",
  reports_analytics: "Reports & Analytics",
  reports_desc_full: "Sales and inventory analytics",
  switch_store_desc: "Manage another store",
  help_support: "Help & Support",
  help_desc: "Get help and support",
  logout_desc: "Sign out of your account",
  basic_info: "Basic Info",
  images: "Images",
  opening_hours: "Opening Hours",
  contact: "Contact",
  amenities: "Amenities",
  opening_hours_desc: "Set your store opening hours for each day of the week",
  amenities_desc: "Select the amenities available at your store",
  accepts_offers: "Incoming offers",
  accepts_offers_desc: "Allow sellers to submit product offers to your store",
  store_logo: "Store Logo",
  cover_image: "Cover Image",
  tap_to_upload: "Tap to upload",
  logo_hint: "Square image recommended (1:1)",
  cover_hint: "Wide image recommended (16:9)",
  address_street: "Street Address",
  address_street_placeholder: "e.g. Mannerheimintie 10",
  postal_code: "Postal Code",
  phone: "Phone",
  website: "Website",
  closed: "Closed",
  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  saturday: "Saturday",
  sunday: "Sunday",
  parking: "Parking",
  wheelchair_accessible: "Wheelchair Accessible",
  free_wifi: "Free WiFi",
  fitting_room: "Fitting Room",
  cafe: "Café",
  card_payment: "Card Payment",
  cash_payment: "Cash Payment",
  customer_email: "Customer email",
  customer_hint: "Identify the customer for a digital receipt",
  customer_optional: "Customer (optional)",
  customer_shows_qr: "Customer shows QR from Fliisi app",
  mobilepay: "MobilePay",
  search_settings: "Search Settings",
  product_type: "Product Type",
  flea_market_products: "Flea Market Products",
  store_products: "Store Products",
  upcoming_only: "Upcoming Only",
  price_range: "Price Range",
  sort_by: "Sort By",
  newest: "Newest",
  oldest: "Oldest",
  ownership: "Ownership",
  price_asc: "Price ↑",
  price_desc: "Price ↓",
  price_low_to_high: "Price: Low to High",
  price_high_to_low: "Price: High to Low",
  reset: "Reset",
  payouts: "Payouts",
  seller_payouts: "Seller Payouts",
  payout_summary: "Payout Summary",
  stripe_balance: "Stripe Balance",
  insufficient_funds: "Insufficient funds.",
  top_up_needed: "Top up needed:",
  top_up: "Top Up Balance",
  items_sold: "Items Sold",
  gross_sales: "Gross Sales",
  to_pay_sellers: "To Pay Sellers",
  ready: "Ready",
  need_setup: "need setup",
  pending_payouts: "Pending Payouts",
  no_pending_payouts: "No pending payouts",
  payouts_appear_here: "Payouts will appear here when items are sold",
  no_stripe: "No Stripe",
  gross: "Gross",
  net_payout: "Net payout",
  no_payout_history: "No payout history",
  history_appear_here: "Processed payouts will appear here",
  net_paid: "Net Paid",
  top_up_to_process: "Top up to process",
  process_payouts: "Process Payouts",
  confirm_payouts: "Confirm Payouts",
  process: "Process",
  history: "History",
  items: "Items",
  item_count_singular: "item",
  items_count_plural: "items",
  payout_history: "Payout History",
  received: "Received",
  payout_setup: "Payout Setup",
  bank_account_connected: "Bank Account Connected",
  payout_ready_desc: "You can receive automatic payouts when your items sell.",
  payout_setup_desc: "Connect your bank account to receive automatic payouts when your items sell. Without this, the market will need to pay you manually.",
  automatic_payouts: "Automatic payouts to your bank",
  fast_transfers: "Fast transfers (1-2 business days)",
  secure_payments: "Secure and encrypted",
  connect_bank_account: "Connect Bank Account",
  multi_device: "Multi-device",
  multi_device_pos: "Multi-device POS",
  multi_device_desc: "Use your phone as a barcode scanner while this screen shows the cart",
  start_register: "Start as Register",
  register_desc: "Generate a code for phone to connect",
  join_as_scanner: "Join as Scanner",
  scanner_desc: "Enter code from register device",
  scanner_mode: "Scanner Mode",
  register_mode: "Register mode",
  waiting_for_scans: "Waiting for scans",
  scanner_will_add: "Items scanned on connected device will appear here",
  enter_session_code: "Please enter a 6-character session code",
  session_not_found: "Session not found or expired",
  item_added: "Item added!",
  camera_permission_needed: "Camera permission is needed to scan barcodes",
  last: "Last",
  not_found: "Not Found",
  scan_barcode: "Scan Barcode",
  scan_customer_qr: "Scan customer QR",
  enter_product_id: "Enter product ID or barcode",
  scan_to_add: "Scan items to add to cart",
  sale_complete: "Sale completed!",
  already_in_cart: "This item is already in the cart",
  info: "Info",
  payment_method: "Payment Method",
  card_external: "Card",
  stripe_terminal: "Stripe",
  charge_card: "Charge Card",
  processing_payment: "Processing Payment",
  present_card: "Please present card on the terminal...",
  manage_reservation: "Manage Reservation",
  days_remaining: "days remaining",
  product_statistics: "Product Statistics",
  total_value: "Total Value",
  sold_value: "Sold Value",
  payment_status: "Payment Status",
  pay_now: "Pay Now",
  actions: "Actions",
  print_price_tags: "Print Price Tags",
  print_tags_desc: "Generate printable labels with QR codes",
  share_products: "Share Products",
  share_products_desc: "Get a shareable link to your products",
  booth: "Booth",
  no_products_in_booth: "No products available in this booth",
  export_csv: "Export to CSV",
  export_csv_desc: "Download product list as spreadsheet",
  danger_zone: "Danger Zone",
  cancel_reservation_desc: "This will unlink all products and cancel your booking",
  cancel_error: "Failed to cancel reservation",
  cancel_reservation_confirm: "Are you sure you want to cancel this reservation? All linked products will be unlinked.",
  export_error: "Failed to export products",
  csv_export_web_only: "CSV export is currently only available on web",
  check_out_my_products: "Check out my products at",
  link_copied: "Link copied to clipboard!",
  map_not_available: "Map view is only available on web",
  switch_to_list: "Switch to List View",
  your_location: "Your location",
  view_store: "View Store",
  actual_count: "Actual Count",
  adjust: "Adjust",
  adjustment_hint: "Enter the reason for this adjustment",
  adjustment_type: "Adjustment Type",
  adjust_stock: "Adjust Stock",
  current_stock: "Current Stock",
  in_stock: "In Stock",
  low: "Low",
  low_stock_hint: "Alert when stock falls below this level",
  negative_stock: "Negative Stock",
  quantity_change: "Quantity Change",
  reorder_hint: "Automatically reorder at this level",
  save_adjustment: "Save Adjustment",
  stock_adjustment: "Stock Adjustment",
  stock_updated: "Stock Updated",
  count_hint: "Enter the actual quantity counted",
  categories: "Categories",
  category: "Category",
  category_has_children: "Category has subcategories",
  category_has_products: "Category has products",
  category_id: "Category ID",
  delete_category_confirm: "Are you sure you want to delete this category?",
  new_category: "New Category",
  no_categories: "No categories",
  no_category: "No Category",
  parent_category: "Parent Category",
  select_category: "Select Category",
  select_parent: "Select Parent",
  subcategories: "Subcategories",
  no_parent: "No Parent",
  add_category_hint: "Add a category to organize products",
  add_item: "Add Item",
  add_items: "Add Items",
  add_product: "Add Product",
  condition: "Condition",
  condition_new: "New",
  condition_like_new: "Like new",
  condition_good: "Good",
  condition_fair: "Fair",
  condition_poor: "Poor",
  min_price: "Min €",
  max_price: "Max €",
  condition_notes: "Condition Notes",
  condition_notes_placeholder: "Describe any wear, damage, or defects",
  cost_price: "Cost Price",
  cost_price_hint: "Your purchase price for margin calculation",
  current_margin: "Current Margin",
  damage_hint: "Note any damage or defects",
  draft_products: "Draft Products",
  minimum_price: "Minimum Price",
  minimum_price_hint: "Lowest acceptable price",
  no_draft_products: "No draft products",
  no_products_in_store: "No products in this store",
  no_products_to_print: "No products to print",
  no_store_products: "No store products",
  ownership_type: "Ownership Type",
  price: "Price",
  product: "product",
  product_id: "Product ID",
  publish: "Publish",
  select_condition: "Select Condition",
  select_product: "Select Product",
  selling_price: "Selling Price",
  target_margin: "Target Margin",
  create_po_hint: "Create a purchase order to track incoming inventory",
  expected: "Expected",
  expected_delivery: "Expected Delivery",
  new_order: "New Order",
  no_orders_in_status: "No orders in this status",
  no_purchase_orders: "No purchase orders",
  order_date: "Order Date",
  order_info: "Order Information",
  order_notes_placeholder: "Add any notes about this order",
  order_received: "Order Received",
  order_saved: "Order Saved",
  purchase_order_id: "Purchase Order ID",
  purchase_orders: "Purchase Orders",
  receive_order: "Receive Order",
  receive_order_confirm: "Mark this order as received?",
  sent: "Sent",
  shipped: "Shipped",
  unit_cost: "Unit Cost",
  quantity_returned: "Quantity Returned",
  return_hint: "Enter quantity being returned",
  enter_supplier_name: "Enter supplier name",
  no_supplier: "No Supplier",
  select_supplier: "Select Supplier",
  supplier_code: "Supplier Code",
  supplier_id: "Supplier ID",
  already_paid: "Already Paid",
  automatic_transfers: "Automatic Transfers",
  charges_enabled: "Charges Enabled",
  checkout: "Checkout",
  complete_setup: "Complete Setup",
  complete_stripe_setup: "Complete Stripe Setup",
  connect_stripe: "Connect Stripe",
  details_submitted: "Details Submitted",
  not_connected: "Not Connected",
  open_stripe_dashboard: "Open Stripe Dashboard",
  pay: "Pay",
  payment: "Payment",
  payment_not_ready: "Payment not ready",
  payment_received: "Payment received",
  payment_successful: "Payment Successful",
  payments: "Payments",
  payments_desc: "Manage your payment settings",
  payouts_enabled: "Payouts Enabled",
  proceed_to_payment: "Proceed to Payment",
  receipt_emailed: "Receipt will be emailed",
  receipt_in_app: "Receipt visible in their app",
  receive_payments: "Receive Payments",
  secure_payment: "Secure Payment",
  stripe_connect_account_id: "Stripe Account ID",
  stripe_connect_explanation: "Connect your Stripe account to receive payments",
  stripe_not_loaded: "Payment system not loaded",
  subtotal: "Subtotal",
  tax: "Tax",
  terminal_support: "Terminal Support",
  totals: "Totals",
  enter_market_name: "Enter market name",
  flea_market_id: "Market ID",
  market: "Market",
  no_space: "No space available",
  space: "Space",
  click_to_place: "Click to place",
  confirm_delete_element: "Delete this element?",
  delete_element: "Delete Element",
  element_details: "Element Details",
  wall: "Wall",
  window: "Window",
  thickness: "Thickness",
  print: "Print",
  print_tags: "Print Tags",
  print_tags_hint: "Print price tags for products",
  tag_size: "Tag Size",
  address: "Address",
  address_placeholder: "Enter address",
  description_en: "Description (English)",
  description_fi: "Description (Finnish)",
  enter_name: "Enter name",
  name_en: "Name (English)",
  name_fi: "Name (Finnish)",
  name_required: "Name is required",
  title_en: "Title (English)",
  title_fi: "Title (Finnish)",
  title_required: "Title is required",
  preferred_language: "Preferred Language",
  after: "After",
  before: "Before",
  dates: "Dates",
  end: "End",
  period: "Period",
  start_point: "Start",
  auto_generated: "Auto-generated",
  cannot_delete: "Cannot delete",
  create_failed: "Failed to create",
  delete_failed: "Failed to delete",
  details: "Details",
  done: "Done",
  no_change: "No changes",
  no_icon: "No icon",
  no_items: "No items",
  qty: "Qty",
  reason: "Reason",
  reason_placeholder: "Enter reason",
  reservation_summary: "Reservation Summary",
  save_failed: "Failed to save",
  save_send: "Save & Send",
  select_icon: "Select Icon",
  shipping: "Shipping",
  thank_you: "Thank you!",
  tap_to_apply: "Tap to apply",
  tap_to_change: "Tap to change",
  failed_to_pick_images: "Failed to pick images",
  gallery_permission_message: "We need access to your photos to add product images",
  permission_required: "Permission Required",
  depth_cm: "Depth (cm)",
  width_cm: "Width (cm)",
  pos_hint: "Use the point of sale to process transactions",
  dropoff_info: "Dropoff Information",
  dropoff_info_placeholder: "When and where can sellers drop off accepted items?",
  sell_myself_at_market: "I want to sell at the flea market myself",
  sell_myself_at_market_desc: "Reserve a table and sell your items yourself on-site",
  sell_on_my_behalf: "I want someone to sell for me",
  sell_on_my_behalf_desc: "Drop off items at a flea market and staff handles the sales",
  sell_immediately: "I want to sell immediately",
  sell_immediately_desc: "Submit offers to stores that buy items directly",
  full_service: "Full-service flea market",
  no_fullservice_markets: "No full-service flea markets in your area yet",
  services_section_desc: "Choose what selling options you offer. You can enable any combination.",
  self_service_mode: "Self-service selling",
  self_service_mode_desc: "Sellers reserve a space and sell their items themselves on-site",
  full_service_mode: "Full-service selling",
  full_service_mode_desc: "Staff handles sales on behalf of sellers",
  full_service_info: "Full-service instructions",
  full_service_info_placeholder: "E.g., item dropoff times, commission rates, payment terms...",
  direct_purchase_mode: "Direct purchase",
  direct_purchase_mode_desc: "Buy items directly from sellers",
  stores_accepting_offers: "Stores Accepting Offers",
  no_stores_accepting_offers: "No stores accepting offers in your area yet",
  submit_offer: "Submit Offer",
  offer_description: "Description",
  offer_description_placeholder: "Describe the item...",
  offer_price: "Your Price",
  item_photos: "Photos",
  add_photos: "Add Photos",
  max_photos: "Max 5 photos per item",
  notes_to_store: "Notes to Store",
  notes_to_store_placeholder: "Any additional information...",
  submit: "Submit",
  submitting: "Submitting...",
  offer_submitted: "Offer submitted! The store will review it soon.",
  add_at_least_one_item: "Please add at least one item",
  enter_item_price: "Please enter a price for all items",
  my_offers: "My Offers",
  offer_pending: "Waiting for response",
  offer_accepted: "Accepted",
  offer_rejected: "Rejected",
  offer_completed: "Completed",
  no_offers_yet: "No offers yet",
  no_offers_description: "Your submitted offers will appear here.",
  offer_details: "Offer Details",
  store_response: "Store Message",
  responded: "Responded",
  your_notes: "Your Notes",
  incoming_offers: "Incoming Offers",
  no_pending_offers: "No pending offers",
  no_accepted_offers: "No accepted offers",
  no_rejected_offers: "No rejected offers",
  no_completed_offers: "No completed offers",
  seller_notes: "Seller Notes",
  your_response: "Your Response",
  accept: "Accept",
  accept_offer: "Accept Offer",
  reject_offer: "Reject Offer",
  message_to_seller: "Message to Seller",
  accept_message_placeholder: "e.g. Thank you! Check dropoff info for delivery times.",
  reject_message_placeholder: "e.g. Unfortunately we cannot accept these items at this time.",
  offer_accepted_message: "Offer accepted",
  offer_rejected_message: "Offer rejected",
  mark_completed_confirm: "Mark this offer as completed?",
  try_again: "Please try again",
  refunds: "Refunds",
  issue_refund: "Issue Refund",
  process_refund: "Process Refund",
  refund_reason: "Refund Reason",
  refund_total: "Refund Total",
  refund_confirmation: "Refund Confirmation",
  refund_processed: "Refund processed successfully",
  confirm_refund: "Confirm Refund",
  enter_reason: "Enter reason",
  fully_refunded: "Fully Refunded",
  no_items_to_refund: "No items to refund",
  cash_refund_manual: "Cash refund - handle manually",
  select_items_to_refund: "Select items to refund",
  connected: "Connected",
  connect_reader: "Connect Reader",
  creating_payment: "Creating payment...",
  no_reader_connected: "No reader connected",
  no_readers_found: "No readers found",
  payment_cancelled: "Payment cancelled",
  reader_connected: "Reader connected",
  reader_disconnected: "Reader disconnected",
  refresh_readers: "Refresh Readers",
  select_reader: "Select Reader",
  terminal_not_ready: "Terminal not ready",
  accepted: "Accepted",
  items_to_offer: "Items to Offer",
  offer_submit_failed: "Failed to submit offer",
  offer_to: "Offer to",
  select_products: "Select Products",
  select_products_hint: "Choose products you want to offer to the store",
  no_products_to_offer: "No products to offer",
  add_products_first_offer: "Add products using the camera or gallery first, then you can offer them to stores.",
  your_price: "Your asking price",
  selected_products: "Selected products",
  pcs: "pcs",
  offers: "Offers",
  add_another_item: "Add Another Item",
  add_item_photos: "Add Item Photos",
  add_photo: "Add Photo",
  additional_notes: "Additional Notes",
  enter_item_title: "Enter item title",
  enter_valid_price: "Enter a valid price",
  expected_price: "Expected Price",
  item: "Item",
  item_description_placeholder: "Describe the item condition, brand, etc.",
  item_title_placeholder: "e.g. Blue Nike sneakers size 42",
  new_product: "New Product",
  photos: "Photos",
  suggested_price: "Suggested Price",
  find_market: "Find Market",
  from: "From",
  map_web_only: "Map is only available in web browser",
  no_markets_found: "No markets found",
  no_products_found: "No products found",
  no_sales_found: "No sales found",
  sales: "Sales",
  search_sales: "Search sales",
  show_list: "Show List",
  show_map: "Show Map",
  check_back_later: "Check back later",
  no_spots_available: "No spots available",
  store_not_found: "Store not found",
  access_denied: "Access Denied",
  click_end_point: "Click end point",
  click_start_point: "Click start point",
  edit_category: "Edit Category",
  icon: "Icon",
  length: "Length",
  line_total: "Line Total",
  no_name: "No name",
  reports: "Reports",
  revenue: "Revenue",
  services: "Services",
  today: "Today",
  door: "Door",
  pillar: "Pillar",
  stairs: "Stairs",
  elevator: "Elevator",
  wc: "WC",
  sink: "Sink",
  electrical_outlet: "Electrical Outlet",
  fire_exit: "Fire Exit",
  entrance: "Entrance",
  counter: "Counter/Register",
  storage: "Storage",
  table: "Table",
  large_table: "Large Table",
  rack: "Rack",
  shelf: "Shelf",
  second_hand: "Second Hand",
  inactive: "Inactive",
  collections: "Collections",
  all_items: "All Items",
  uncategorized: "Uncategorized",
  create_collection: "Create Collection",
  edit_collection: "Edit Collection",
  delete_collection: "Delete Collection",
  collection_name: "Collection Name",
  collection_name_placeholder: "e.g., Summer clothes, Electronics...",
  collection_color: "Color",
  move_to_collection: "Move to Collection",
  remove_from_collection: "Remove from Collection",
  no_collections: "No collections yet",
  create_first_collection: "Create your first collection to organize items",
  collection_created: "Collection created",
  collection_updated: "Collection updated",
  collection_deleted: "Collection deleted",
  items_moved: "Items moved to collection",
  confirm_delete_collection: "Delete this collection? Items will be moved to Uncategorized.",
  select_collection: "Select Collection",
  offer_entire_collection: "Offer Entire Collection",
  search_products_or_stores: "Search products or stores...",
  finds_for_you: "Finds for you",
  stores_near_you: "Stores near you",
  show_less: "Show less",
  how_fliisi_works: "How Fliisi works",
  browse_products_online: "Browse products online",
  find_nearest_stores: "Find nearest stores",
  buy_from_stores: "Buy from stores",
  user_default: "User",
  sign_in_full: "Sign in",
  sign_in_for_qr: "Sign in to view your QR code",
  show_at_checkout: "Show at checkout",
  qr_receipt_hint: "The cashier scans this to link the purchase to your profile",
  save_favorites_track_purchases: "Save favorites and track purchases",
  create_account: "Create account",
  my_purchases: "My purchases",
  about_fliisi: "About Fliisi",
  fliisi_description: "Fliisi connects flea markets and customers. Browse online, buy in store. Sustainable shopping made easy.",
  opening_gallery: "Opening gallery...",
  products_that_interest_you: "Products that might interest you",
  no_purchases_yet: "No purchases yet",
  purchases_empty_hint: "When you buy products and the seller links the purchase to your account, they will appear here.",
  purchase_count: "Purchases",
  voided: "Voided",
  unnamed_product: "Unnamed product",
  unknown_product: "Unknown product",
  discount: "Discount",
  yesterday: "Yesterday",
  recent_searches: "Recent searches",
  popular_categories_label: "Popular categories",
  search_nearby: "Search nearby",
  find_stores_on_map: "Find stores on map",
  search_products_stores: "Search products, stores...",
  try_different_keywords: "Try different keywords",
  results: "results",
  no_results_found: "No results",
  map_label: "Map",
  show_store: "View store",
  recent_drafts: "Recent drafts",
  take_photo_to_start: "Take a photo of a product to start selling",
  products_awaiting_link: "products awaiting linking",
  active_reservations_count: "active reservations",
  reserve_selling_spot: "Reserve a selling spot",
  manage_your_store: "Manage your store",
  transactions: "Transactions",
  transaction_history: "Transaction History",
  void_sale: "Void Sale",
  void_reason: "Reason",
  void_reason_hint: "Why is this sale being voided?",
  confirm_void: "Confirm Void",
  sale_voided: "Voided",
  partial_return: "Return Items",
  no_transactions: "No transactions yet",
  select_items_to_return: "Select items to return",
  return_selected: "Return Selected",
  items_returned: "Items returned",
  sale_void_success: "Sale voided successfully",
  store_info: "Store info",
  hide_details: "Hide",
  filters: "Filters",

  // Email templates
  email_receipt_preview: "Receipt {receiptNumber} — {storeName}",
  email_receipt_number: "Receipt {receiptNumber}",
  email_receipt_total: "Total",
  email_receipt_payment_method: "Payment method",
  email_receipt_thanks: "Thank you for your purchase!",
  email_receipt_via_fliisi: "This receipt was sent via Fliisi.",
  email_payment_card: "Card",
  email_payment_cash: "Cash",
  email_payment_mobilepay: "MobilePay",
  email_invite_heading: "Store invitation",
  email_invite_body: "{inviterName} has invited you to join {storeName} as {role}.",
  email_invite_accept: "Accept invitation",
  email_invite_ignore: "If you weren't expecting this invitation, you can safely ignore this email.",
  email_role_cashier: "cashier",
  email_role_admin: "admin",
  email_role_super_admin: "super admin",
  email_unsubscribe: "Unsubscribe from these emails",




} as const
